(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => { const link = event.target.closest('.ch-mobile-nav a'); if (link) link.closest('details').removeAttribute('open'); });
document.addEventListener('keydown', (event) => { if(event.key === 'Escape') { const menu=document.querySelector('.ch-mobile-nav[open]'); if(menu){menu.removeAttribute('open');menu.querySelector('summary').focus();} } });
function updateChCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const counter = document.getElementById('ch-cart-count');
      if (!counter) return;

      counter.textContent = cart.item_count;

      if (cart.item_count > 0) {
        counter.style.display = 'block';
      } else {
        counter.style.display = 'none';
      }
    });
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');

  if (form) {
    setTimeout(updateChCartCount, 700);
  }
});

document.addEventListener('cart:update', updateChCartCount);
document.addEventListener('cart:refresh', updateChCartCount);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-homepage"] && !Shopify.designMode) return;
  try {
    
function initCercleHome(){const root=document.getElementById('lch-home');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';const find=id=>root.querySelector('#'+id);
const menuButton = root.querySelector('.menu-toggle');
const navigation = root.querySelector('#navigation');
function closeMenu() { navigation.classList.remove('open'); menuButton.setAttribute('aria-expanded', 'false'); }
menuButton.addEventListener('click', () => { const opened = navigation.classList.toggle('open'); menuButton.setAttribute('aria-expanded', String(opened)); });
navigation.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeMenu(); } });

root.querySelectorAll('.product-card').forEach(card => {
  const summary = card.querySelector('summary');
  const title = card.querySelector('h3')?.textContent?.trim() || 'cette édition';
  if (summary) summary.setAttribute('aria-label', `Voir le contenu de ${title}`);
});

const method = [
  ['PARTIR DE LA SITUATION', 'Un avis négatif après le séjour.', 'Dans CH-03, choisissez l’outil consacré aux avis clients. La méthode aide à reconnaître les faits, répondre avec tact et définir la suite.'],
  ['DONNER LE BON CONTEXTE', 'Vos faits. Votre ton. Vos procédures.', 'Précisez le problème signalé, le canal de réponse et la prochaine étape autorisée. Utilisez le Profil Établissement pour garder votre signature.'],
  ['GARDER LE DERNIER MOT', 'Une base soignée. Votre validation.', 'Copiez le prompt dans votre assistant IA, puis vérifiez sa réponse. Contrôlez les faits et les engagements, ajustez la formulation et validez avant d’envoyer.']
];
root.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
  const index = Number(button.dataset.step);
  root.querySelectorAll('[data-step]').forEach(item => { const active = item === button; item.classList.toggle('active', active); item.setAttribute('aria-pressed', String(active)); });
  root.querySelector('.panel-number').textContent = ['I', 'II', 'III'][index];
  ['method-label', 'method-title', 'method-text'].forEach((id, i) => { find(id).textContent = method[index][i]; });
}));

const promptText = find('demo-text').textContent;
const demos = {
  prompt: ['UNE INSTRUCTION STRUCTURÉE', 'Donnez un rôle, des faits et un cadre.', promptText],
  result: ['UNE RÉPONSE À RELIRE ET À ADAPTER', 'Reconnaître. Répondre. Proposer une suite.', 'Merci d’avoir partagé votre expérience. Nous sommes heureux que la chambre vous ait plu et sommes désolés que le bruit ait perturbé votre repos. Nous vous invitons à contacter notre réception afin que notre équipe puisse examiner la situation avec vous. Votre retour nous permet de mieux comprendre votre séjour et de lui apporter toute l’attention nécessaire.']
};
root.querySelectorAll('[data-demo]').forEach(button => button.addEventListener('click', () => {
  root.querySelectorAll('[data-demo]').forEach(item => { const active = item === button; item.classList.toggle('active', active); item.setAttribute('aria-pressed', String(active)); });
  ['demo-label', 'demo-title', 'demo-text'].forEach((id, i) => { find(id).textContent = demos[button.dataset.demo][i]; });
}));
find('copy-prompt').addEventListener('click', async () => {
  const status = find('copy-status');
  try { await navigator.clipboard.writeText(promptText); status.textContent = 'Prompt copié. Personnalisez-le avant de l’utiliser dans votre assistant IA.'; }
  catch { status.textContent = 'La copie automatique n’est pas disponible. Sélectionnez le texte de l’onglet « Le prompt » pour le copier.'; }
});
if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting) { entry.target.classList.add('revealed'); observer.unobserve(entry.target); } }), { threshold: .06 });
  root.querySelectorAll('.product-card, .benefit-grid article, .profile-grid a').forEach(el => { el.classList.add('reveal'); observer.observe(el); });
}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCercleHome);}else{initCercleHome();}document.addEventListener('shopify:section:load',initCercleHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
